(function() {
  define('bazemont/content/pageSection',['angular'], function() {
    'use strict';
    return angular.module('bazemontContentPageSection', []).component('bazemontContentPageSection', {
      templateUrl: '/assets/javascripts/bazemont/content/pageSection.html',
      bindings: {
        section: '=',
        first: '<',
        last: '<'
      },
      require: {
        parent: '^^bazemontContentPage'
      },
      controller: [
        'TlhConfirmModalService', function(TlhConfirmModalService) {
          var isNewEmptySection, toolbarButtons, toolbarButtonsMD, toolbarButtonsSM, toolbarButtonsXS, vm;
          vm = this;
          vm.isNewSection = !vm.section.id;
          toolbarButtons = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'insertHR', '-', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          toolbarButtonsMD = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          toolbarButtonsSM = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '-', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          toolbarButtonsXS = ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          vm.editorConfig = {
            paragraphFormat: {
              H3: 'Titre paragraphe',
              N: 'Texte simple'
            },
            pluginsEnabled: ['align', 'draggable', 'file', 'image', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'quote', 'table', 'url', 'video'],
            imageDefaultAlign: 'left',
            imageDefaultDisplay: 'inline',
            toolbarButtons: toolbarButtons,
            toolbarButtonsMD: toolbarButtonsMD,
            toolbarButtonsSM: toolbarButtonsSM,
            toolbarButtonsXS: toolbarButtonsXS
          };
          vm["delete"] = function() {
            var message;
            if (!isNewEmptySection(vm.section)) {
              message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette section ?</p>';
              return TlhConfirmModalService.open(message).result.then(function(result) {
                if (result.confirm) {
                  return vm.section.isActive = false;
                }
              });
            } else {
              return vm.section.isActive = false;
            }
          };
          isNewEmptySection = function(section) {
            return !section.id && !section.title && !section.body;
          };
          vm.moveUp = function() {
            return vm.parent.moveSectionUp(vm.section);
          };
          vm.moveDown = function() {
            return vm.parent.moveSectionDown(vm.section);
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=pageSection.js.map
;
